/* Sofiya Mart — global storefront behaviour (cart, drawer, header, sliders, tabs). No dependencies. */
(function () {
  'use strict';

  var SM = (window.SM = window.SM || {});
  var S = SM.settings || {};
  var T = SM.strings || {};
  var CART_SECTION = 'sm-cart-drawer';

  /* ---------------- Utilities ---------------- */
  SM.qs = function (sel, root) { return (root || document).querySelector(sel); };
  SM.qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  SM.debounce = function (fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  };

  SM.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || S.moneyFormat || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelimiters(cents, 2);
        case 'amount_no_decimals': return withDelimiters(cents, 0);
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return withDelimiters(cents, 0, ' ', '');
        case 'amount_with_space_separator': return withDelimiters(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return withDelimiters(cents, 2, ' ', '.');
        default: return withDelimiters(cents, 2);
      }
    });
  };

  /* ---------------- Toast ---------------- */
  var toastTimer;
  SM.toast = function (msg) {
    var el = SM.qs('[data-sm-toast]');
    if (!el || !msg) return;
    el.textContent = msg;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 300);
    }, 2600);
  };

  /* ---------------- Scroll lock ---------------- */
  var lockCount = 0;
  SM.lock = function () { lockCount++; document.documentElement.classList.add('sm-lock'); };
  SM.unlock = function () {
    lockCount = Math.max(0, lockCount - 1);
    if (!lockCount) document.documentElement.classList.remove('sm-lock');
  };

  /* ---------------- Generic drawer (cart / filters / menu) ---------------- */
  var lastFocus = null;
  SM.openDrawer = function (drawer) {
    if (!drawer || drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    var overlay = drawer.previousElementSibling && drawer.previousElementSibling.matches('.sm-overlay') ? drawer.previousElementSibling : null;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    SM.lock();
    var focusEl = drawer.querySelector('[data-sm-drawer-focus]') || drawer.querySelector('button, [href], input');
    if (focusEl) setTimeout(function () { focusEl.focus({ preventScroll: true }); }, 50);
  };
  SM.closeDrawer = function (drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    var overlay = drawer.previousElementSibling && drawer.previousElementSibling.matches('.sm-overlay') ? drawer.previousElementSibling : null;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    SM.unlock();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };

  /* ---------------- Cart ---------------- */
  function cartDrawer() { return SM.qs('[data-sm-cart-drawer]'); }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          var err = new Error(data.description || data.message || T.error);
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  SM.cart = {
    renderSections: function (sections) {
      if (!sections || !sections[CART_SECTION]) return;
      var doc = new DOMParser().parseFromString(sections[CART_SECTION], 'text/html');
      var fresh = doc.querySelector('[data-sm-cart-inner]');
      var current = SM.qs('[data-sm-cart-inner]');
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        var count = fresh.getAttribute('data-count');
        current.setAttribute('data-count', count);
        SM.cart.setCount(count);
      }
    },
    setCount: function (count) {
      count = parseInt(count, 10) || 0;
      SM.qsa('[data-sm-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
      document.dispatchEvent(new CustomEvent('sm:cart-count', { detail: { count: count } }));
    },
    refresh: function () {
      var url = (S.rootUrl || '/').replace(/\/$/, '') + '/?sections=' + CART_SECTION;
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (sections) { SM.cart.renderSections(sections); })
        .catch(function () {});
    },
    add: function (items, trigger) {
      if (trigger) trigger.classList.add('is-loading');
      return postJSON(S.cartAddUrl, { items: items, sections: CART_SECTION, sections_url: window.location.pathname })
        .then(function (data) {
          SM.cart.renderSections(data.sections);
          document.dispatchEvent(new CustomEvent('sm:cart-added', { detail: data }));
          var mode = S.afterAdd || 'drawer';
          var drawer = cartDrawer();
          if (mode === 'page') {
            window.location.href = S.cartUrl;
          } else if (mode === 'drawer' && drawer) {
            SM.openDrawer(drawer);
          } else {
            SM.toast(T.added);
          }
          return data;
        })
        .catch(function (e) {
          SM.toast(e.message || T.error);
          throw e;
        })
        .finally(function () { if (trigger) trigger.classList.remove('is-loading'); });
    },
    change: function (line, quantity) {
      var inner = SM.qs('[data-sm-cart-inner]');
      if (inner) inner.classList.add('is-busy');
      return postJSON(S.cartChangeUrl, { line: line, quantity: quantity, sections: CART_SECTION, sections_url: window.location.pathname })
        .then(function (data) {
          SM.cart.renderSections(data.sections);
          document.dispatchEvent(new CustomEvent('sm:cart-changed', { detail: data }));
          if (document.body.classList.contains('template-cart')) window.location.reload();
          return data;
        })
        .catch(function (e) { SM.toast(e.message || T.error); })
        .finally(function () { var i = SM.qs('[data-sm-cart-inner]'); if (i) i.classList.remove('is-busy'); });
    },
    note: SM.debounce(function (note) {
      postJSON(S.cartUpdateUrl, { note: note }).catch(function () {});
    }, 400)
  };

  // Keep in sync with any built-in Horizon add-to-cart (Shopify standard events)
  document.addEventListener('shopify:cart:lines-update', function (e) {
    var p = e && e.promise;
    if (p && p.then) p.then(function () { SM.cart.refresh(); }).catch(function () {});
    else setTimeout(SM.cart.refresh, 800);
  });

  /* ---------------- Delegated clicks ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var opener = t.closest('[data-sm-cart-open]');
    if (opener && cartDrawer() && opener.getAttribute('data-sm-cart-open') !== 'page') {
      e.preventDefault();
      SM.openDrawer(cartDrawer());
      return;
    }

    var closer = t.closest('[data-sm-drawer-close]');
    if (closer) {
      e.preventDefault();
      SM.closeDrawer(closer.closest('.sm-drawer') || SM.qs('.sm-drawer.is-open'));
      return;
    }

    if (t.matches('.sm-overlay.is-open')) {
      SM.closeDrawer(t.nextElementSibling);
      return;
    }

    var quick = t.closest('[data-sm-quick-add]');
    if (quick) {
      e.preventDefault();
      SM.cart.add([{ id: Number(quick.getAttribute('data-sm-quick-add')), quantity: 1 }], quick).catch(function () {});
      return;
    }

    var bundle = t.closest('[data-sm-add-bundle]');
    if (bundle) {
      e.preventDefault();
      var ids = (bundle.getAttribute('data-sm-add-bundle') || '').split(',').filter(Boolean);
      if (ids.length) SM.cart.add(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), bundle).catch(function () {});
      return;
    }

    var lineBtn = t.closest('[data-sm-line-change]');
    if (lineBtn) {
      e.preventDefault();
      SM.cart.change(Number(lineBtn.getAttribute('data-line')), Number(lineBtn.getAttribute('data-qty')));
      return;
    }

    var sw = t.closest('[data-sm-card-swatch]');
    if (sw) {
      e.preventDefault();
      var card = sw.closest('[data-sm-card]');
      SM.qsa('[data-sm-card-swatch]', card).forEach(function (b) { b.classList.toggle('is-active', b === sw); });
      var img = card && card.querySelector('.sm-card__img--main');
      if (img && sw.getAttribute('data-img')) {
        img.src = sw.getAttribute('data-img');
        img.srcset = sw.getAttribute('data-srcset') || '';
        var media = img.closest('.sm-card__media');
        if (media) media.classList.remove('has-hover');
      }
      var url = sw.getAttribute('data-url');
      if (url && card) SM.qsa('[data-sm-card-link]', card).forEach(function (a) { a.href = url; });
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-sm-line-qty]')) {
      SM.cart.change(Number(t.getAttribute('data-line')), Math.max(0, parseInt(t.value, 10) || 0));
    } else if (t.matches('[data-sm-cart-note]')) {
      SM.cart.note(t.value);
    } else if (t.matches('[data-sm-localization]')) {
      var form = t.closest('form');
      if (form) form.submit();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = SM.qs('.sm-drawer.is-open');
      if (open) SM.closeDrawer(open);
      SM.qsa('[data-sm-header]').forEach(function (h) { if (h.smCloseMega) h.smCloseMega(); });
    }
  });

  /* ---------------- Components ---------------- */
  var components = {};
  SM.register = function (name, init) { components[name] = init; };
  SM.init = function (root) {
    root = root || document;
    Object.keys(components).forEach(function (name) {
      var sel = '[data-sm-' + name + ']';
      var els = SM.qsa(sel, root);
      if (root !== document && root.matches && root.matches(sel)) els.unshift(root);
      els.forEach(function (el) {
        if (el.__smInit && el.__smInit[name]) return;
        el.__smInit = el.__smInit || {};
        el.__smInit[name] = true;
        try { components[name](el); } catch (err) { console.error('[SM] ' + name, err); }
      });
    });
  };

  /* Horizontal rails with prev/next arrows. Arrows drive the currently visible rail inside the wrapper. */
  SM.register('rail-controls', function (wrap) {
    var prev = wrap.querySelector('[data-sm-rail-prev]');
    var next = wrap.querySelector('[data-sm-rail-next]');
    function rail() {
      var rails = SM.qsa('[data-sm-rail]', wrap);
      for (var i = 0; i < rails.length; i++) if (rails[i].offsetParent !== null) return rails[i];
      return rails[0];
    }
    function update() {
      var r = rail();
      if (!r) return;
      var max = r.scrollWidth - r.clientWidth - 2;
      if (prev) prev.disabled = r.scrollLeft <= 2;
      if (next) next.disabled = r.scrollLeft >= max;
    }
    function go(dir) { var r = rail(); if (r) r.scrollBy({ left: dir * r.clientWidth * 0.75, behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(document.dir === 'rtl' ? 1 : -1); });
    if (next) next.addEventListener('click', function () { go(document.dir === 'rtl' ? -1 : 1); });
    SM.qsa('[data-sm-rail]', wrap).forEach(function (r) { r.addEventListener('scroll', SM.debounce(update, 60), { passive: true }); });
    window.addEventListener('resize', SM.debounce(update, 150));
    wrap.smUpdateRail = update;
    update();
  });

  /* Tabs (product tabs etc.) */
  SM.register('tabs', function (wrap) {
    var tabs = SM.qsa('[role="tab"]', wrap);
    var viewAll = wrap.querySelector('[data-sm-tabs-link]');
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (viewAll && tab.getAttribute('data-url')) viewAll.href = tab.getAttribute('data-url');
      if (wrap.smUpdateRail) wrap.smUpdateRail();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        n.focus();
        select(n);
      });
    });
    wrap.smSelectTab = function (index) { if (tabs[index]) select(tabs[index]); };
  });

  /* Accordions that keep a single item open */
  SM.register('accordion', function (wrap) {
    if (wrap.getAttribute('data-sm-accordion') !== 'single') return;
    var items = SM.qsa('details', wrap);
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  });

  /* Hero slider with progress tabs */
  SM.register('hero', function (hero) {
    var slides = SM.qsa('[data-sm-slide]', hero);
    var tabs = SM.qsa('[data-sm-hero-tab]', hero);
    var interval = (parseInt(hero.getAttribute('data-interval'), 10) || 7) * 1000;
    var autoplay = hero.getAttribute('data-autoplay') === 'true' && slides.length > 1;
    var index = 0;
    var timer = null;
    var paused = false;
    hero.style.setProperty('--sm-hero-interval', interval + 'ms');

    function show(i, user) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) s.removeAttribute('inert'); else s.setAttribute('inert', '');
        var v = s.querySelector('video');
        if (v) { if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }
      });
      tabs.forEach(function (t, n) {
        var on = n === index;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        var bar = t.querySelector('[data-sm-progress]');
        if (bar) {
          bar.style.animation = 'none';
          void bar.offsetWidth;
          bar.style.animation = '';
        }
      });
      var bg = slides[index].getAttribute('data-bg');
      if (bg) hero.style.setProperty('--sm-hero-bg', bg);
      hero.classList.toggle('is-playing', autoplay && !paused);
      if (user) restart();
    }
    function restart() {
      clearInterval(timer);
      if (autoplay && !paused) timer = setInterval(function () { show(index + 1); }, interval);
    }
    tabs.forEach(function (t, n) { t.addEventListener('click', function () { show(n, true); }); });
    var prev = hero.querySelector('[data-sm-hero-prev]');
    var next = hero.querySelector('[data-sm-hero-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1, true); });
    if (next) next.addEventListener('click', function () { show(index + 1, true); });

    function setPaused(v) { paused = v; hero.classList.toggle('is-playing', autoplay && !paused); restart(); }
    hero.addEventListener('mouseenter', function () { setPaused(true); });
    hero.addEventListener('mouseleave', function () { setPaused(false); });
    hero.addEventListener('focusin', function () { setPaused(true); });
    hero.addEventListener('focusout', function () { setPaused(false); });
    document.addEventListener('visibilitychange', function () { setPaused(document.hidden); });

    // Swipe
    var sx = null;
    hero.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1), true);
      sx = null;
    });

    hero.smShow = show;
    show(0);
    restart();
  });

  /* Header: mega menu, sticky state, predictive search */
  SM.register('header', function (header) {
    var triggers = SM.qsa('[data-sm-mega-trigger]', header);
    var openId = null;
    var closeTimer;
    var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');

    function panel(id) { return header.querySelector('[data-sm-mega-panel="' + id + '"]'); }
    function open(id) {
      clearTimeout(closeTimer);
      if (openId === id) return;
      close(true);
      var p = panel(id);
      if (!p) return;
      openId = id;
      p.hidden = false;
      requestAnimationFrame(function () { p.classList.add('is-open'); });
      triggers.forEach(function (t) { if (t.getAttribute('data-sm-mega-trigger') === id) t.setAttribute('aria-expanded', 'true'); });
    }
    function close(immediate) {
      if (!openId) return;
      var p = panel(openId);
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      openId = null;
      if (p) {
        p.classList.remove('is-open');
        if (immediate) p.hidden = true;
        else setTimeout(function () { if (!p.classList.contains('is-open')) p.hidden = true; }, 200);
      }
    }
    header.smCloseMega = function () { close(); };

    triggers.forEach(function (t) {
      var id = t.getAttribute('data-sm-mega-trigger');
      t.addEventListener('mouseenter', function () { if (hoverable.matches) open(id); });
      t.addEventListener('focus', function () { if (hoverable.matches) open(id); });
      t.addEventListener('click', function (e) {
        if (!hoverable.matches || t.tagName === 'BUTTON') {
          if (openId !== id) { e.preventDefault(); open(id); }
          else if (t.tagName === 'BUTTON') close();
        }
      });
    });
    SM.qsa('[data-sm-nav-plain]', header).forEach(function (a) {
      a.addEventListener('mouseenter', function () { if (hoverable.matches) close(); });
    });
    header.addEventListener('mouseleave', function () {
      if (!hoverable.matches) return;
      closeTimer = setTimeout(close, 180);
    });
    header.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    document.addEventListener('click', function (e) { if (openId && !header.contains(e.target)) close(); });

    // Expose header height for sticky galleries / filter sidebars
    var setOffset = function () {
      var h = header.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--sm-header-offset', Math.round(h + 16) + 'px');
    };
    setOffset();
    window.addEventListener('resize', SM.debounce(setOffset, 150));

    // Sticky shadow
    var sticky = header.closest('[data-sm-sticky]');
    if (sticky) {
      var onScroll = function () { sticky.classList.toggle('is-scrolled', window.scrollY > 8); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Predictive search
    SM.qsa('[data-sm-search]', header).forEach(function (form) {
      var input = form.querySelector('input[type="search"]');
      var results = form.querySelector('[data-sm-search-results]');
      if (!input || !results || !S.predictiveSearchUrl) return;
      var ctrl;
      var last = '';
      function hide() { results.hidden = true; input.setAttribute('aria-expanded', 'false'); }
      var run = SM.debounce(function () {
        var q = input.value.trim();
        if (q.length < 2) { hide(); return; }
        if (q === last && !results.hidden) return;
        last = q;
        if (ctrl) ctrl.abort();
        ctrl = 'AbortController' in window ? new AbortController() : null;
        var url = S.predictiveSearchUrl + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,query,page,article&resources[limit]=6&section_id=sm-predictive-search';
        fetch(url, ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-sm-predictive]');
            results.innerHTML = inner ? inner.innerHTML : '';
            results.hidden = !inner;
            input.setAttribute('aria-expanded', inner ? 'true' : 'false');
          })
          .catch(function () {});
      }, 220);
      input.addEventListener('input', run);
      input.addEventListener('focus', function () { if (results.innerHTML.trim() && input.value.trim().length > 1) results.hidden = false; });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { hide(); } });
    });
  });

  /* Simple drawer toggles: <button data-sm-drawer-toggle="#id"> */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sm-drawer-toggle]');
    if (!b) return;
    var d = SM.qs(b.getAttribute('data-sm-drawer-toggle'));
    if (!d) return;
    e.preventDefault();
    if (d.classList.contains('is-open')) SM.closeDrawer(d); else SM.openDrawer(d);
  });

  /* Image thumbnails switching a main image (featured product spotlight) */
  SM.register('thumbs', function (wrap) {
    var main = wrap.querySelector('[data-sm-thumbs-main]') || wrap.querySelector('.sm-spot__main img');
    SM.qsa('[data-sm-thumb]', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        SM.qsa('[data-sm-thumb]', wrap).forEach(function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
        if (main) {
          main.src = btn.getAttribute('data-src');
          main.srcset = btn.getAttribute('data-srcset') || '';
        }
      });
    });
  });

  /* Newsletter / forms: nothing needed — native Shopify forms. */

  /* ---------------- Boot ---------------- */
  function boot() { SM.init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { SM.init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var block = e.target;
    var hero = block.closest('[data-sm-hero]');
    if (hero && hero.smShow) {
      var slides = SM.qsa('[data-sm-slide]', hero);
      var i = slides.indexOf(block.closest('[data-sm-slide]') || block);
      if (i > -1) hero.smShow(i, true);
    }
    var tabsWrap = block.closest('[data-sm-tabs]');
    if (tabsWrap && tabsWrap.smSelectTab) {
      var idx = block.getAttribute('data-tab-index');
      if (idx !== null) tabsWrap.smSelectTab(Number(idx));
    }
    var det = block.closest('details') || (block.matches('details') ? block : null);
    if (det) det.open = true;
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-sm-cart-drawer]')) SM.openDrawer(cartDrawer());
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-sm-cart-drawer]')) SM.closeDrawer(cartDrawer());
  });
})();
